import { useState, useEffect } from 'react';

import { getSessionStorageItem } from '@revenuemarket/browser';
import { useRouter } from 'next/router';

import LightThemeLogo from '~assets/images/clobe_light_theme.svg';
import IndukLogo from '~assets/images/partners/induk/induk.svg';
import InsungLogo from '~assets/images/partners/insung/insung.svg';
import JiwooLogo from '~assets/images/partners/jiwoo/jiwoo.svg';
import LoumLogo from '~assets/images/partners/loum/loum.svg';
import SaveTaxLogo from '~assets/images/partners/savetax/savetax.svg';
import ThekLogo from '~assets/images/partners/thek/thek.svg';
import ToptaxLogo from '~assets/images/partners/toptax/toptax.svg';
import { css } from '~libs/emotion';

const logoMap = {
  savetax: SaveTaxLogo,
  induk: IndukLogo,
  insung: InsungLogo,
  jiwoo: JiwooLogo,
  loum: LoumLogo,
  thek: ThekLogo,
  toptax: ToptaxLogo,
};

const logoStyleMap = {
  default: css`
    width: 120px;
    height: 24px;
    cursor: pointer;
  `,
  savetax: undefined, // savetax는 스타일 적용 안 함
  induk: undefined, // induk는 스타일 적용 안 함
  insung: undefined, // insung는 스타일 적용 안 함
  jiwoo: undefined, // jiwoo는 스타일 적용 안 함
  loum: undefined, // loum은 스타일 적용 안 함
  thek: undefined, // thek는 스타일 적용 안 함
  toptax: undefined, // toptax는 스타일 적용 안 함
};

const useLogo = () => {
  const router = useRouter();
  const [partnerFromStorage, setPartnerFromStorage] = useState<string | null>(null);
  const [isMounted, setIsMounted] = useState(false);

  // 클라이언트 사이드에서만 session storage 읽기
  useEffect(() => {
    setIsMounted(true);

    const updatePartnerFromStorage = () => {
      const partner = getSessionStorageItem<string>('partner');
      setPartnerFromStorage(partner || null);
    };

    // 초기 로드 시 session storage 읽기
    updatePartnerFromStorage();

    // storage 이벤트 리스너 추가 (다른 탭에서 변경 시 감지)
    window.addEventListener('storage', updatePartnerFromStorage);

    return () => {
      window.removeEventListener('storage', updatePartnerFromStorage);
    };
  }, []);

  // SSR 시에는 null 반환 (로고 숨김)
  if (!isMounted) {
    return { logo: null, partner: null, logoStyle: undefined };
  }

  const { partner } = router.query;
  const effectivePartner = Array.isArray(partner) ? partner[0] : partner || partnerFromStorage;

  const selectedLogo =
    effectivePartner && logoMap[effectivePartner as keyof typeof logoMap]
      ? logoMap[effectivePartner as keyof typeof logoMap]
      : LightThemeLogo;

  const logoStyle =
    effectivePartner && effectivePartner in logoStyleMap
      ? logoStyleMap[effectivePartner as keyof typeof logoStyleMap]
      : logoStyleMap.default;

  return {
    logo: selectedLogo,
    partner: effectivePartner,
    logoStyle,
  };
};

export default useLogo;
